module.exports = __webpack_public_path__ + "img/model-img1.e95872bf.png";